module.exports = __webpack_public_path__ + "static/media/illustration-car-on-the-bridge.61b98819.svg";